export const GET_PROGRAMS_REQUEST = "GET_PROGRAMS_REQUEST";
export const GET_PROGRAMS_SUCCESS = "GET_PROGRAMS_SUCCESS";
export const GET_PROGRAMS_FAIL = "GET_PROGRAMS_FAIL";
export const GET_PROGRAMS_NETWORK_ERROR = "GET_PROGRAMS_NETWORK_ERROR";
export const GET_RESPONSE_STATUS = "GET_RESPONSE_STATUS";
export const RESET_ORDERS = "RESET_ORDERS";
